import createAxiosInstance, { promiseTimeout } from "../axiosClient"

export async function incluirVenda(pedido: any, token: string) {
    const axiosClient = await createAxiosInstance()
    const request = axiosClient.post('/incluir/pedido', pedido, {
        headers: {'x-access-token': token}
    })
    return promiseTimeout(request)
}